import { render, staticRenderFns } from "./source_report_page.vue?vue&type=template&id=af276d40&scoped=true"
import script from "./source_report_page.vue?vue&type=script&lang=js"
export * from "./source_report_page.vue?vue&type=script&lang=js"
import style0 from "./source_report_page.vue?vue&type=style&index=0&id=af276d40&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af276d40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af276d40')) {
      api.createRecord('af276d40', component.options)
    } else {
      api.reload('af276d40', component.options)
    }
    module.hot.accept("./source_report_page.vue?vue&type=template&id=af276d40&scoped=true", function () {
      api.rerender('af276d40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/source/source_report_page.vue"
export default component.exports